import React, { useEffect } from 'react';
import './AboutUs.scss';
import AOS from 'aos';
import 'aos/dist/aos.css';

function AboutUs() {

  useEffect(() => {
    AOS.init({
      duration: 500,
      once: true,
    });
  }, []);

  return (
  <section id="about" className="section-container">
  <div className="about-content">
    <div data-aos="fade-right" className="about-header">
      <h2 className="title">Qui suis-je ?</h2>
      <p>
        Je suis Ludivine, alias <strong>Pokélu</strong> ! Depuis mon plus jeune âge, j’ai grandi entourée d’animaux. 
        Ma grand-mère partageait son quotidien avec une multitude de compagnons à poils, à plumes et à écailles. 
        Cette passion m'a naturellement conduite à en faire mon métier !
      </p>
      <p>
        Après plusieurs années d’études et d’expériences auprès des animaux, j’ai créé mon entreprise dédiée à 
        l’éducation canine et féline ainsi qu’au remplacement d’élevage.
      </p>
      <div className='flex'>
      <a href="/a-propos" className="custom-card-button">Connaître mon histoire</a>
      </div>
    </div>

    <div className="about-details">
      <div data-aos="fade-right" className="about-image">
        <img src="./img/about/pokelu-et-tsuna.webp" alt="Pokélu et tsuna" width="300"/>
      </div>
      <div data-aos="fade-left" className="about-text">
        <h3 className="title">Quel est mon rôle ?</h3>
        <p>
          <strong>Comportement & Éducation :</strong> Mon objectif est de vous aider à construire une relation harmonieuse avec votre animal, 
          en favorisant la compréhension mutuelle et en réduisant les comportements indésirables. 
        </p>
        <p>
          <strong>Remplacement d’élevage :</strong> Durant vos absences, je prends en charge votre élevage avec sérieux et bienveillance, 
          assurant le bon fonctionnement de votre structure et le <strong>bien-être</strong> de vos petits protégés.
        </p>
      </div>
    </div>

    <div data-aos="fade-right" className="about-mission">
      <h3 className="title">Pourquoi me choisir ?</h3>
      <p>
        Vous recherchez une <strong>spécialiste</strong> du comportement canin et félin ou une remplaçante de confiance ? 
        Ne cherchez plus, vous êtes à la bonne adresse ! Avec <strong>Pokélu</strong>, offrez à votre compagnon une éducation bienveillante 
        et partez en toute sérénité.
      </p>
    </div>
  </div>
</section>
  );
}

export default AboutUs;